import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { navigate } from "@reach/router";
import Button from "@material-ui/core/Button";
import styles from "./styles";

class UserDetection extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { classes, t } = this.props;
    return (
      <React.Fragment>
        <div className={classes.headerSection}>
          <i className={`material-icons ${classes.headerIcon}`}>close</i>
        </div>
        <div className={classes.body}>
          <div className={classes.titleSection}>
            <h1 className={classes.title}>
              {t("screens.userDetection.title", { brand: "Toyota" })}
            </h1>
          </div>
          <div className={classes.actionsSection}>
            <Button
              className={classes.actions}
              variant="contained"
              size="large"
              color="primary"
              onClick={() => navigate("profiles")}
            >
              {t("screens.userDetection.yes-action")}
            </Button>
            <Button
              className={classes.actions}
              variant="contained"
              size="large"
              color="primary"
              onClick={() => navigate("profiles")}
            >
              {t("screens.userDetection.no-action")}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

UserDetection.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(UserDetection))
);
